import { ParamError } from "@/views/zhiji/js/common/errors.js";
import { quesSaveType } from "@/views/zhiji/js/common/constants.js";
import widgetManager from "./widgets/widgetManager.js";

import i18n from "@/i18n";

// 转换成后台需要的参数结构
export function checkValidate(state) {
    const info = state.questionInfo;

    const needCheckParam = quesSaveType.DRAFT != state.saveType;

    checkQuestionParam(info); // 校验必填字段，草稿状态和上线都需要校验

    needCheckParam && checkAnswer(state, needCheckParam);
}

// 意图实体答案转换成后台需要的参数结构
export function checkAnswerValidate(state) {
    const needCheckParam = quesSaveType.DRAFT != state.saveType;

    needCheckParam && checkAnswer(state, needCheckParam);
}

function checkQuestionParam(question) {
    if (question.sceneClassId == "def" || question.sceneClassId == "") {
        throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.sceneClassifyTip"));
    } else if (!question.standQuestion) {
        throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.standQuesTip"));
    } else if (!question.optionTip) {
        throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.shortbarDefTip"));
    }
}

function checkAnswer(state, needCheckParam) {
    let ret = [];
    let answerCount = 0; // 展示的问题数量

    state.answers.forEach(function(answer) {
        if (answer.updateState != "") {
            checkProps(answer.props, needCheckParam);
            checkContent(answer.contents, needCheckParam);
            checkOption(answer.options, needCheckParam);
        }

        if (answer.updateState != "delete") {
            answerCount++;
        }
    });

    if (needCheckParam && answerCount === 0) {
        throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.editQuesAns"));
    }

    return ret;
}

function checkProps(props, needCheckParam) {
    let gameId = window.localStorage.getItem("gameId");
    let users = props.effectUser;
    let channels = props.effectChannel.channel;
    // 特殊处理，只有在内容助手下需校验
    if (gameId === "80002") {
        let noEffectUser = users.indexOf("178") === -1 && users.indexOf("179") === -1;

        let noEffectChannel = channels.indexOf("mobile") === -1 && channels.indexOf("lite") === -1;

        if (noEffectUser && needCheckParam) {
            throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.noEffectModel"));
        }

        if (noEffectChannel && needCheckParam) {
            throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.noEffectChannel"));
        }
    }
}

function checkContent(contents, needCheckParam) {
    let contentCount = 0; // 问题的回答数量

    contents.forEach(function(content) {
        const widgetHandler = widgetManager.clientMap[content.wtType];

        if (content.updateState != "" && content.updateState != "delete" && needCheckParam && widgetHandler) {
            widgetHandler.checkContent.call(null, content);
        }

        if (content.updateState != "delete") {
            contentCount++;
        }
    });

    if (needCheckParam && contentCount === 0) {
        throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.noAnswerDetail"));
    }
}

function checkOption(options, needCheckParam) {
    let ret = [];

    options.forEach(function(option) {
        if (option.updateState != "" && option.updateState != "delete") {
            needCheckParam && checkOptionParam(option); // 校验快捷栏
        }
    });

    return ret;
}

function checkOptionParam(option) {
    if (!option.name && option.itemType !== "labor") {
        throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.shortbarName"));
    } else if (!option.questionId && option.itemType !== "labor") {
        throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.shortbarLinkQues"));
    } else if (option.itemType === "labor" && !option.formId) {
        throw new ParamError(i18n.t("zhiji.answer.laborSearchLabel"));
    }
}
